"use client";

// Step 6.7.2 / AC164: thin client component that mounts the catalog
// filter URL <-> store sync. The catalog page is a Server Component, so
// this wrapper exists purely to run the sync hook on the client side.

import { useCatalogFiltersSync } from "@/stores/useCatalogFiltersSync";

export function CatalogFiltersSyncMount() {
  useCatalogFiltersSync();
  return null;
}
